import React from "react";
import { useLocation } from "react-router-dom";
import "../styles/VerifyNotice.css";

const VerifyNotice = () => {
  const location = useLocation();
  const email = location.state?.email;

  const handleResend = async () => {
    if (!email) return alert("No email found.");
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/auth/resend-verification`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      alert(data.message || data.error);
    } catch (err) {
      alert("Something went wrong");
    }
  };

  return (
    <div className="verify-notice-container">
      <img src="/verify-illustration.png" alt="Verify Email" className="verify-img" />
      <h2>Check your inbox 📩</h2>
      <p>
        We sent a verification link to <strong>{email}</strong>. <br />
        Please verify your email to continue.
      </p>
      <button className="resend-btn" onClick={handleResend}>
        ✉️ Resend Verification Email
      </button>
    </div>
  );
};

export default VerifyNotice;
